import { Pipe, PipeTransform } from '@angular/core'

const DEFAULT_FIXED = 1

@Pipe({
  name: 'VMFDays',
})
export class DaysPipe implements PipeTransform {
  transform(value: string, minFractionDigits?: number): string {
    if (value == null) {
      return '—'
    }
    const index = value.indexOf('d')
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    value = value.substring(0, index - 2)
    return `${Number(value).toFixed(minFractionDigits || DEFAULT_FIXED)} days`
  }
}
